import { Components, Theme } from "@mui/material";
import type {} from "@mui/x-date-pickers/themeAugmentation";

/**
 * This theme is used in the MUI baseTheme to style the date picker globally.
 */
export const MuiDatePickerTheme: Components<Theme>["MuiPickersLayout"] = {
  styleOverrides: {
    root: () => {
      // TODO: Figure out why year text is too big
      return {
        // "& .MuiDateTimePickerToolbar-dateContainer": {
        //   "& .MuiTypography-root": {
        //     "&:first-of-type": {
        //       fontSize: "1.5rem", // Make year text smaller
        //     },
        //   },
        // },
        "& .MuiDateTimePickerToolbar-timeContainer": {
          alignItems: "center", // Center align time container
          "& .MuiTypography-root": {
            lineHeight: 1,
          },
        },
      };
    },
  },
};
